import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const AdminRoute = () => {
  const { isAuthenticated, isLoading, getCurrentUserRole, user } = useAuth();
  const [userRole, setUserRole] = useState(null);
  const [roleLoading, setRoleLoading] = useState(true);

  useEffect(() => {
    const checkRole = async () => {
      if (isAuthenticated && user) {
        try {
          const role = await getCurrentUserRole();
          console.log("Role obtida no AdminRoute:", role);
          setUserRole(role);
        } catch (error) {
          console.error("Erro ao obter role:", error);
          setUserRole("user"); // Fallback para user se houver erro
        }
      }
      setRoleLoading(false);
    };

    if (isAuthenticated && user) {
      checkRole();
    } else if (!isAuthenticated) {
      setRoleLoading(false);
    }
  }, [isAuthenticated, user, getCurrentUserRole]);

  if (isLoading || roleLoading) {
    return null; // O App.js já exibe o spinner de carregamento
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />; // Redireciona para o login se não estiver autenticado
  }

  console.log("AdminRoute - userRole:", userRole, "isAuthenticated:", isAuthenticated);
  
  return userRole === "admin" ? (
    <Outlet />
  ) : (
    <Navigate to="/dashboard" replace />
  );
};

export default AdminRoute;
